import { FormikProps } from 'formik';
import { CardBody, CardHeader, Col, Input, Label } from 'reactstrap';
import { CustomerFormType } from 'types/customer/customerTypes';
import { useSelector } from 'react-redux';
import { RootState } from 'slices';
import { useTranslation } from 'react-i18next';
import useWindowSize from 'Components/Hooks/WindowSizeHook';

export default function CustomerContactSection({
  formik,
}: {
  formik: FormikProps<CustomerFormType>;
}) {
  const { t } = useTranslation();
  const { showAllValidateErrors } = useSelector((s: RootState) => s.Customer);
  const { width } = useWindowSize();
  const isMobile = width <= 1024;

  return (
    <>
      <CardHeader className="mb-4 mx-0 px-0">
        <div
          className="px-0 mx-0"
          style={{
            fontSize: '1rem',
            fontWeight: '600',
            display: 'inline-flex',
          }}
        >
          <div className={`text-success`}>
            <i className="ri-user-settings-line"></i>
          </div>
          <div className="px-1">{t('Contact Information')}</div>
        </div>
      </CardHeader>
      <CardBody
        style={{
          paddingLeft: isMobile ? '' : '2rem',
          paddingRight: isMobile ? '' : '2rem',
        }}
      >
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.last_name"
            className="col-sm-3 col-form-label"
          >
            {t('Contact Name')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerContact.last_name"
              name="customerContact.last_name"
              value={formik.values.customerContact.last_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={255}
            />
            {(formik.touched.customerContact?.last_name &&
              formik.errors.customerContact?.last_name &&
              typeof formik.errors.customerContact?.last_name === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.last_name}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.phoneNumber"
            className="col-sm-3 col-form-label"
          >
            {t('Phone Number')}
          </Label>
          <Col sm={9}>
            <Input
              type="tel"
              className="form-control"
              id="customerContact.phoneNumber"
              name="customerContact.phoneNumber"
              value={formik.values.customerContact.phoneNumber}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={20}
            />
            {(formik.touched.customerContact?.phoneNumber &&
              formik.errors.customerContact?.phoneNumber &&
              typeof formik.errors.customerContact?.phoneNumber === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.phoneNumber}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.email"
            className="col-sm-3 col-form-label"
          >
            {t('Email')}
          </Label>
          <Col sm={9}>
            <Input
              type="email"
              className="form-control"
              id="customerContact.email"
              name="customerContact.email"
              value={formik.values.customerContact.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.email &&
              formik.errors.customerContact?.email &&
              typeof formik.errors.customerContact?.email === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.email}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.facebook"
            className="col-sm-3 col-form-label"
          >
            {t('Facebook')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerContact.facebook"
              name="customerContact.facebook"
              value={formik.values.customerContact.facebook}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.facebook &&
              formik.errors.customerContact?.facebook &&
              typeof formik.errors.customerContact?.facebook === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.facebook}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.line"
            className="col-sm-3 col-form-label"
          >
            {t('Line')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerContact.line"
              name="customerContact.line"
              value={formik.values.customerContact.line}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.line &&
              formik.errors.customerContact?.line &&
              typeof formik.errors.customerContact?.line === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.line}
              </div>
            ) : null}
          </Col>
        </div>
        <div className="mb-3 row">
          <Label
            htmlFor="customerContact.instagram"
            className="col-sm-3 col-form-label"
          >
            {t('Instagram')}
          </Label>
          <Col sm={9}>
            <Input
              type="text"
              className="form-control"
              id="customerContact.instagram"
              name="customerContact.instagram"
              value={formik.values.customerContact.instagram}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              maxLength={100}
            />
            {(formik.touched.customerContact?.instagram &&
              formik.errors.customerContact?.instagram &&
              typeof formik.errors.customerContact?.instagram === 'string') ||
            (formik.isValid === false &&
              formik.errors.customerInfo?.accountNumber &&
              showAllValidateErrors === true) ? (
              <div className={`text-danger `}>
                {formik.errors.customerContact?.instagram}
              </div>
            ) : null}
          </Col>
        </div>

        <div className="mb-3 row"></div>
      </CardBody>
    </>
  );
}
